import clsx from "clsx";

import { useEffect, useState } from "react";
import useLocalStorage from "@/base/hooks/useLocalStorage";

import * as styles from "./styles.module.scss";

export function InfoBar(data: Pick<HeaderTemplate, "info_bar">) {
  const [storedValue, setValue] = useLocalStorage<boolean>(
    "headerInfobarCookie",
    false
  );

  function allowCookies() {
    setValue(true);
  }

  const [showInfobar, setShowInfobar] = useState<boolean>(false);

  useEffect(() => {
    if (!storedValue) {
      setShowInfobar(true);
    }
  }, [storedValue]);

  return (
    <div
      className={clsx(styles.infobarContainer, "container")}
      style={{
        opacity: showInfobar ? 1 : 0,
        display: showInfobar ? "block" : "none",
      }}
    >
      <div className={styles.infobar}>
        <p>{data.info_bar}</p>
        <button
          className={styles.crossButton}
          type="button"
          onClick={() => {
            allowCookies();
            setShowInfobar((p) => !p);
          }}
        />
      </div>
    </div>
  );
}
